import http from "./request";

export const adminLogin = (body) => http.post("/api/auth/admin/login", body);
